module.exports = __webpack_public_path__ + "7e6efe729feecec3dec9878fe1ae5e53.svg";